export enum TimerWorkerCommand {
    SetInterval,
    SetTimeout,
    ClearInterval,
    ClearTimeout
}

export interface ITimerCommand {
    command: TimerWorkerCommand;
}

export class SetIntervalCommand implements ITimerCommand {
    command = TimerWorkerCommand.SetInterval;
    constructor(
        public delay: number,
        public timerId: number
    ) {}
}

export class SetTimeoutCommand implements ITimerCommand {
    command = TimerWorkerCommand.SetTimeout;
    constructor(
        public delay: number,
        public timerId: number
    ) {}
}

export class ClearIntervalCommand implements ITimerCommand {
    command = TimerWorkerCommand.ClearInterval;
    constructor(public timerId: number) {}
}

export class ClearTimeoutCommand implements ITimerCommand {
    command = TimerWorkerCommand.ClearTimeout;
    constructor(public timerId: number) {}
}

export enum TimerResponseType {
    Tick,
    Error
}

export interface ITimerResponse {
    type: TimerResponseType;
}

export class TimerResponse implements ITimerResponse {
    type = TimerResponseType.Tick;
    constructor(public timerId: number) {}
}

export class TimerErrorResponse implements ITimerResponse {
    type = TimerResponseType.Error;
    constructor(
        public message: string,
        public data?: any
    ) {}
}
